import { FileType } from '@office-start/document-types';
export function getFileLocationUrl(item) {
    var isUpcomingMeeting = item.fileType === FileType.UpcomingMeeting;
    if (isUpcomingMeeting) {
        // TODO: in OfficeHome, this is "joinUrl", we may need to port that property to office-start to support this scenario.
        return item.url;
    }
    if (item.isEmailAttachment) {
        return item.url;
    }
    return item.attributionUrl;
}
//# sourceMappingURL=getFileLocationUrl.js.map